module.exports = __webpack_public_path__ + "static/img/6.238e939b.png";